import { ListHolidayItem } from 'generated/api-client';
import { formatCalendarDate, toCalendarDate } from 'utils/date';
import * as Yup from 'yup';

const overlaps = (
  holiday: ListHolidayItem,
  startDate: Date,
  endDate: Date,
): boolean =>
  holiday.startDate <= toCalendarDate(endDate) &&
  toCalendarDate(startDate) <= holiday.endDate;

export const holidayFormValidationSchema = (
  viewHolidays: ListHolidayItem[],
  currentHolidayId?: number,
) =>
  Yup.object()
    .shape({
      startDate: Yup.date().nullable().required('Date de début requise !'),
      // The picker bounds the choice, but a start moved forward can leave a stale end.
      endDate: Yup.date()
        .nullable()
        .required('Date de fin requise !')
        .when('startDate', ([startDate], schema) =>
          startDate
            ? schema.min(
                startDate,
                'La date de fin ne peut pas être avant la date de début !',
              )
            : schema,
        ),
    })
    .test('no-overlap', '', (values, context) => {
      const { startDate, endDate } = values ?? {};
      if (!startDate || !endDate) return true;

      const conflict = viewHolidays.find(
        (holiday) =>
          holiday.id !== currentHolidayId &&
          overlaps(holiday, startDate, endDate),
      );

      if (!conflict) return true;

      return context.createError({
        path: 'endDate',
        message: `Un congé existe déjà du ${formatCalendarDate(
          conflict.startDate,
        )} au ${formatCalendarDate(conflict.endDate)} !`,
      });
    });
